export class HtmlLoader {
	public static loadImage(src: string): Promise<HTMLImageElement> {
		return new Promise<HTMLImageElement>(function(resolve, reject): void {
			
			const img = new Image();

			function done() {
				img.removeEventListener("load", done);
				img.removeEventListener("error", done);

				if(img.naturalWidth) {
					resolve(img);
				}
				else {
					reject("Image load error");
				}
			}

			img.addEventListener("load", done);
			img.addEventListener("error", done);
			img.src = src;
		});
	}

	public static async loadIFrame(src: string): Promise<HTMLIFrameElement> {

		const iframe = document.createElement('iframe');

		iframe.src = src;

		return iframe;

		// return new Promise<HTMLIFrameElement>(function(resolve, reject): void {
		// 	const iframe = document.createElement('iframe');

		// 	function done() {
		// 		iframe.removeEventListener("load", done);
		// 		//iframe.removeEventListener("error", done);

		// 		console.log("iframe done")
		// 	}

		// 	iframe.addEventListener("load", done);
		// 	//iframe.addEventListener("error", () => false);
		// 	iframe.src = src;
		// });
	}
}